import React from 'react'
import { Button, Image, Input, Select, Switch, Checkbox, message } from 'antd'
import {
  CloseCircleTwoTone,
  UploadOutlined,
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons'
import './tableInfoView.css'
import SpecialSwitch from '../specialSwitch/specialSwitch'
import { fetchClubTableType } from '../../../../api/clubProfession'
import { validateImageFile } from '../../../../util'

const Option = Select.Option

const typeOptions = [
  {
    id: 0,
    name: '台球',
  },
  {
    id: 1,
    name: '休闲区',
  },
  {
    id: 2,
    name: '棋牌',
  },
  {
    id: 3,
    name: '飞镖机',
  },
]
const timeEndList = [
  { type: 4, name: '套餐时长结束' },
  { type: 2, name: '卡券时长结束' },
  { type: 5, name: '预订时长结束' },
  { type: 3, name: '团购时长结束' },
]
export default class extends React.Component {
  state = {
    id: -1, // 球台id
    name: '', // 球台名称
    fileList: [], // 球台图片组
    groupId: '', // 选择的组id
    clz: 0, // 选择的类型id
    hourPrice: '', // 基本价格
    minConsumption: 0, // 最低消费
    lampNumber: '', // 灯箱编号
    order: '', // 桌台排序
    postpaid: true, // 是后付费
    instantlyCheckout: false, // 是商品即结
    settings: [
      {
        id: -1, //开台类型设置ID
        startType: 4, //开台类型：0.常规；2.卡券；3.团购；4.套餐；5.预订
        needFlashingReminder: false, //需要闪灯提醒
        needWechatReminder: false, //需要微信提醒
        option: 2, //选项：1.用户；2.俱乐部
        operation: 1, //操作：1.关灯；2.强制进入后付费
      },
      {
        id: -1, //开台类型设置ID
        startType: 2, //开台类型：0.常规；2.卡券；3.团购；4.套餐；5.预订
        needFlashingReminder: false, //需要闪灯提醒
        needWechatReminder: false, //需要微信提醒
        option: 2, //选项：1.用户；2.俱乐部
        operation: 1, //操作：1.关灯；2.强制进入后付费
      },
      {
        id: -1, //开台类型设置ID
        startType: 5, //开台类型：0.常规；2.卡券；3.团购；4.套餐；5.预订
        needFlashingReminder: false, //需要闪灯提醒
        needWechatReminder: false, //需要微信提醒
        option: 2, //选项：1.用户；2.俱乐部
        operation: 1, //操作：1.关灯；2.强制进入后付费
      },
      {
        id: -1, //开台类型设置ID
        startType: 3, //开台类型：0.常规；2.卡券；3.团购；4.套餐
        needFlashingReminder: false, //需要闪灯提醒
        needWechatReminder: false, //需要微信提醒
        option: 2, //选项：1.用户；2.俱乐部
        operation: 1, //操作：1.关灯；2.强制进入后付费
      },
    ],
    showFlash: false,
    showWxMess: false,
    groupList: [],
    isShowReserve: false,
  }

  componentDidMount() {
    const clubId = sessionStorage.getItem('club_id')
    const isClubTest = sessionStorage.getItem('club_testing')

      this.setState({
        isShowReserve: true,
      })


    this.getTableType()
    const { tableInfoData } = this.props
    if (tableInfoData) {
      const { group, minConsumption, photos, settings, table } = tableInfoData
      const {
        id,
        name,
        hourPrice,
        clz,
        postpaid,
        lampNumber,
        instantlyCheckout,
        order,
      } = table
      let newSettings = [...this.state.settings]
      if (settings && settings.length > 0) {
        const mapArray = [].concat(this.state.settings)
        newSettings = mapArray.map((oItem) => {
          let newItem = { ...oItem }
          const fItem = settings.find((ft) => ft.startType == oItem.startType)
          if (fItem) {
            const { option } = fItem
            newItem = {
              ...fItem,
              option: option < 1 ? 2 : option,
            }
          }
          return newItem
        })
      }
      this.setState(
        {
          id,
          name,
          fileList:
            photos.length > 0
              ? [{ url: photos[0], uploaded: true, file: null }]
              : [],
          groupId: group.id,
          clz,
          hourPrice: hourPrice,
          minConsumption: minConsumption,
          lampNumber,
          order,
          postpaid,
          instantlyCheckout,
          settings: newSettings,
        },
        this.notificationData
      )
    } else {
      this.notificationData()
    }
  }

  // 获取业务分组列表
  getTableType = () => {
    fetchClubTableType().then((res) => {
      if (res.status != 1) {
        message.error(res.detail)
        return
      }
      this.setState({
        groupList: res.data,
      })
    })
  }

  // 数据变化通知上层
  notificationData = () => {
    this.props.onDataChange && this.props.onDataChange(this.state)
  }

  onInputChange = (key, value) => {
    this.setState(
      {
        [key]: value,
      },
      this.notificationData
    )
  }

  onSwitchChange = (typeObj, key, value) => {
    const { settings } = this.state
    const findArray = [].concat(settings)
    const findItem = findArray.find((item) => item.startType == typeObj.type)
    const findIndex = findArray.findIndex(
      (item) => item.startType == typeObj.type
    )
    findItem[key] = value
    if (key == 'option' && value == 1) {
      findItem['operation'] = 1
    }
    findArray.splice(findIndex, 1, findItem)
    console.log('替换数据', findArray)
    this.setState(
      {
        settings: findArray,
      },
      this.notificationData
    )
  }

  // 选择图片
  onFileUpload = (e) => {
    const that = this
    const file = e.target.files[0]
    if (!validateImageFile(file)) {
      e.target.value = ''
      return
    }
    let fd = this.state.fileList
    const reader = new FileReader()
    reader.onload = (res) => {
      const basedata = res.target.result
      if (basedata) {
        fd.push({ url: basedata, uploaded: false, file: file })
        that.setState(
          {
            fileList: fd,
          },
          that.notificationData
        )
      }
    }
    reader.readAsDataURL(file)
  }

  // 删除图片
  deleteFlie = (index) => {
    let fl = this.state.fileList
    fl.splice(index, 1)
    this.setState(
      {
        fileList: fl,
      },
      this.notificationData
    )
  }

  findSettingValue = (type, key) => {
    const { settings } = this.state
    const findItem = settings.find((item) => item.startType == type)
    return findItem[key]
  }

  render() {
    const {
      groupList,
      fileList,
      name,
      groupId,
      clz,
      hourPrice,
      minConsumption,
      lampNumber,
      order,
      postpaid,
      instantlyCheckout,
      showFlash,
      showWxMess,
      isShowReserve,
    } = this.state

    return (
      <div className="table_info_view_container">
        <div className="info_content_container">
          <div className="upload_view">
            <span className="info_default_text">桌台图片：</span>
            <div className="upload-class">
              {fileList &&
                fileList.length > 0 &&
                fileList.map((item, index) => {
                  return (
                    <div className="upload-image-class-view" key={index}>
                      <div
                        className="upload-close-class"
                        onClick={() => this.deleteFlie(index)}
                      >
                        <CloseCircleTwoTone
                          style={{
                            width: '20px',
                            height: '20px',
                            fontSize: '20px',
                          }}
                          twoToneColor="#ff6e6e"
                        />
                      </div>
                      <Image
                        className="upload-image-view"
                        src={item.url}
                        alt=""
                      />
                    </div>
                  )
                })}
              {fileList.length < 1 && (
                <Button className="add-photo-class">
                  <UploadOutlined />
                  <input
                    className="file-input-class"
                    accept=".jpg,.jpeg,.png"
                    type="file"
                    onChange={this.onFileUpload}
                  />
                </Button>
              )}
            </div>
          </div>
          <div className="info_cell">
            <span className="info_default_text">桌台名称：</span>
            <Input
              className="info_input_class"
              placeholder="请输入桌台名称"
              value={name}
              onChange={(e) => this.onInputChange('name', e.target.value)}
            ></Input>
          </div>
          <div className="info_cell">
            <span className="info_default_text">所属分组：</span>
            <Select
              size="large"
              placeholder="选择一个桌台分组"
              style={{ flex: 0.8, height: '100%' }}
              value={groupId}
              onChange={(value) => {
                this.setState(
                  {
                    groupId: value,
                  },
                  this.notificationData
                )
              }}
            >
              {groupList.length > 0 &&
                groupList.map((item, idx) => {
                  return (
                    <Option value={item.id} key={idx}>
                      {item.name}
                    </Option>
                  )
                })}
            </Select>
          </div>
          <div className="info_cell">
            <span className="info_default_text">所属类型：</span>
            <Select
              size="large"
              placeholder="选择一个桌台类型"
              style={{ flex: 0.8, height: '100%' }}
              value={clz}
              onChange={(value) => {
                this.setState(
                  {
                    clz: value,
                  },
                  this.notificationData
                )
              }}
            >
              {typeOptions.map((item, idx) => {
                return (
                  <Option value={item.id} key={idx}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </div>
          <div className="info_cell">
            <span className="info_default_text">基本价格：</span>
            <Input
              className="info_input_class"
              placeholder="请输入价格[元/小时]"
              value={hourPrice}
              onChange={(e) => this.onInputChange('hourPrice', e.target.value)}
            ></Input>
          </div>
          <div className="info_cell">
            <span className="info_default_text">最低消费[分钟]：</span>
            <Input
              className="info_input_class"
              placeholder="请输入最低消费"
              value={minConsumption}
              onChange={(e) =>
                this.onInputChange('minConsumption', e.target.value)
              }
            ></Input>
          </div>
          <div className="info_cell">
            <span className="info_default_text">灯箱编号：</span>
            <Input
              className="info_input_class"
              placeholder="灯箱编号应在0-150之间"
              value={lampNumber}
              onChange={(e) => this.onInputChange('lampNumber', e.target.value)}
            ></Input>
          </div>
          <div className="info_cell">
            <span className="info_default_text">桌台编号：</span>
            <Input
              className="info_input_class"
              placeholder="请输入桌台编号"
              value={order}
              onChange={(e) => this.onInputChange('order', e.target.value)}
            ></Input>
          </div>
        </div>
        <div className="info_content_container">
          <div className="info_cell">
            <span className="info_default_text">计时模式(后付费)：</span>
            <Switch
              checked={postpaid}
              size="large"
              onChange={(value) => {
                this.setState(
                  {
                    postpaid: value,
                  },
                  this.notificationData
                )
              }}
            />
          </div>
          {postpaid &&
            timeEndList.map((item, idx) => {
              if (item.type == 5 && !isShowReserve) {
                return null
              }
              return (
                <div className="switchs_content" key={idx}>
                  <div className="info_default_text">{item.name}后：</div>
                  <SpecialSwitch
                    leftLabel={item.type != 3 ? '' : '关灯'}
                    rightLabel={item.type != 3 ? '' : '继续计时计费'}
                    defaultValue={this.findSettingValue(
                      item.type,
                      item.type != 3 ? 'option' : 'operation'
                    )}
                    onLargeSwitchChange={(value) => {
                      this.onSwitchChange(
                        item,
                        item.type != 3 ? 'option' : 'operation',
                        value
                      )
                    }}
                  />
                  {item.type != 3 &&
                    this.findSettingValue(item.type, 'option') == 2 && (
                      <SpecialSwitch
                        size
                        leftLabel="关灯"
                        rightLabel="继续计时计费"
                        defaultValue={this.findSettingValue(
                          item.type,
                          'operation'
                        )}
                        onLargeSwitchChange={(value) => {
                          this.onSwitchChange(item, 'operation', value)
                        }}
                      />
                    )}
                </div>
              )
            })}
          {postpaid && (
            <div
              className="info_show_cell"
              onClick={() =>
                this.setState((prevState) => ({
                  showFlash: !prevState.showFlash,
                }))
              }
            >
              <span className="info_default_text text_width">
                时长结束前闪灯提醒
              </span>
              <span className="arrow_text">
                {showFlash ? <UpOutlined /> : <DownOutlined />}
              </span>
            </div>
          )}

          {postpaid &&
            showFlash &&
            timeEndList.map((item, idx) => {
              if (item.type == 5 && !isShowReserve) {
                return null
              }
              return (
                <div className="flash_box" key={idx}>
                  <Checkbox
                    checked={this.findSettingValue(
                      item.type,
                      'needFlashingReminder'
                    )}
                    onChange={(e) => {
                      this.onSwitchChange(
                        item,
                        'needFlashingReminder',
                        e.target.checked
                      )
                    }}
                  >
                    {item.name}前闪灯提醒
                  </Checkbox>
                </div>
              )
            })}
          {postpaid && (
            <div
              className="info_show_cell"
              onClick={() =>
                this.setState((prevState) => ({
                  showWxMess: !prevState.showWxMess,
                }))
              }
            >
              <span className="info_default_text text_width">
                时长结束前发送微信信息
              </span>
              <span className="arrow_text">
                {showWxMess ? <UpOutlined /> : <DownOutlined />}
              </span>
            </div>
          )}

          {postpaid &&
            showWxMess &&
            timeEndList.map((item, idx) => {
              if (item.type == 3) {
                return null
              }
              if (item.type == 5 && !isShowReserve) {
                return null
              }
              return (
                <div className="flash_box" key={idx}>
                  <Checkbox
                    checked={this.findSettingValue(
                      item.type,
                      'needWechatReminder'
                    )}
                    onChange={(e) => {
                      this.onSwitchChange(
                        item,
                        'needWechatReminder',
                        e.target.checked
                      )
                    }}
                  >
                    {item.name}前发送微信信息
                  </Checkbox>
                </div>
              )
            })}
          <div className="info_cell">
            <span className="info_default_text">商品即时结账：</span>
            <Switch
              checked={instantlyCheckout}
              size="large"
              onChange={(value) => {
                this.setState(
                  {
                    instantlyCheckout: value,
                  },
                  this.notificationData
                )
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/tableInfoView/tableInfoView.js